import React from 'react';
import moment from 'moment';
import axios from '../axios';

const SectionReservationSummary = ({ summary, onEdit = () => {}, onCancel = () => {},}) => {
  if (!summary) return null;
  const handleCancel = async () => {
    if (!window.confirm('カラオケ予約をキャンセルしますか？')) return;
    try {
      await axios.post(
        `/api/places/${summary.place_id}/reserve_cancel`,
        { reservation_id: summary.id }
      );
      onCancel();
    } catch (e) {
      alert('キャンセルに失敗しました。時間をおいて再度お試しください。');
    }
  };

  return (
    <div className="container col-md-8 col-lg-6">
      <div className="alert alert-info mt-3">
        <div className="d-flex align-items-center mb-2">
          <h5 className="mb-0">カラオケ予約内容</h5>
          <div className="ml-auto d-flex">
            <button type="button" className="btn btn-sm btn-outline-secondary text-nowrap" onClick={onEdit}>
              編集
            </button>
            <button type="button" className="btn btn-sm ml-2 btn-outline-danger text-nowrap" onClick={handleCancel}>
              キャンセル
            </button>
          </div>
        </div>
        <div>
          <p className="mb-1"><strong>店舗:</strong> {summary.place_name}</p>
          <p className="mb-1"><strong>日時:</strong>{' '}
            {moment(summary.start_at).format('M月D日 HH:mm')} 〜{' '}
            {moment(summary.end_at).format('M月D日 HH:mm')}
          </p>
          <p className="mb-1"><strong>人数:</strong> {summary.num_people} 人</p>
          {summary.request_detail && (
            <p className="mb-0"><strong>要望:</strong> {summary.request_detail}</p>
          )}
          <p className="mb-1 text-fz-12px">※ご希望の日時でお取りできなかった場合は、アプリ内メッセージにてご連絡いたします。
          </p>
        </div>
      </div>
    </div>
  );
};

export default SectionReservationSummary;
